<script>
import ViewBase from '@/components/ViewBase/ViewBase'
export default {
  name: 'ViewDynamic',
  extends: ViewBase,
  beforeMount () {
    this.api(this.$route.path)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ViewDynamic/ViewDynamic.vue